var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container, 'settings_button']},[_c('a',{class:_vm.$style.logoutButton,attrs:{"href":_vm.settingsUrl}},[_c('img',{attrs:{"src":require("@images/settings.svg"),"alt":_vm.t('settings'),"width":"26","height":"26"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ded1e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","vector":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsButton.vue
// module id = XbO4
// module chunks = 0